// components
import Validation from '@/js/components/forms/validation';

class Contact {
  constructor() {
    this.dom = {
      formApplication: document.getElementById('form-application'),
      alertScroll: document.querySelector('.js-alert-scroll:not(.d-none)'),
    };

    this.components = {
      applicationFormValidation: null,
    };

    this.mount();
  }

  mount() {
    if (this.dom.formApplication) {
      this.components.applicationFormValidation = new Validation(this.dom.formApplication);
    }

    if (this.dom.alertScroll) {
      this.dom.alertScroll.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

if (document.getElementById('page-application')) {
  // eslint-disable-next-line no-new
  new Contact();
}
